import { render, staticRenderFns } from "./panelInventoryMarket.vue?vue&type=template&id=35dc9df6&lang=pug"
import script from "./panelInventoryMarket.vue?vue&type=script&lang=js"
export * from "./panelInventoryMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports